export const bngPaymentRef = 'bng-payment-ref';
export const bngPaymentType = 'bng-payment';
